import { html } from "lit";
import { customElement, property, query } from "lit/decorators.js";
import { BaseElement } from "../BaseElement";
import { LightTheme } from "../ThemeLight";

import { styles } from "./PlaceReportEditorDialog.style";
import { IPlaceReport } from "../../../main";

export function showPlaceReportEditorDialog(props: any, approved: any, cancelled: any = () => {}) {
    const dialog = Object.assign(document.createElement("ds-place-report-editor-dialog"), props);
    dialog.addEventListener("on-approved", () => {
        approved();
    });
    dialog.addEventListener("on-cancel", () => {
        cancelled();
    });
    document.body.append(dialog);
}

@customElement("ds-place-report-editor-dialog")
export class PlaceReportEditorDialog extends BaseElement {
    static override styles = [styles, LightTheme];

    @property({ type: Boolean }) open = false;
    @property({ type: Object }) placeReport?: IPlaceReport;
    @property({ type: Boolean }) isTidal = false;

    @query("#confirm-dialog") _confirmDialog: HTMLElement | undefined;

    public show() {
        (this._confirmDialog as any).show();
    }

    private hide() {
        (this._confirmDialog as any).hide();
    }

    protected override firstUpdated(): void {
        if (this.open) {
            this.show();
        }
    }
    protected cancel() {
        this.dispatchEvent(
            new CustomEvent("on-cancel", {
                bubbles: true,
                composed: true,
                detail: {},
            })
        );
        this.hide();
    }

    override render() {
        if (this.placeReport) {
            return html`<sl-dialog label="${"Trip Editor"}" id="confirm-dialog">
                <ds-place-report-editor
                    .report=${this.placeReport}
                    ?tidal=${this.isTidal}
                    @ds-accept=${async () => {
                        this.hide();
                    }}
                    @ds-cancel=${() => {
                        this.hide();
                    }}
                ></ds-place-report-editor
            ></sl-dialog>`;
        }
        return html``;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-place-report-editor-dialog": PlaceReportEditorDialog;
    }
}
